<script setup>
import Table from '@/Shared/Components/Tables/Table.vue'
import TableTextColumn from '@/Shared/Components/Tables/columns/TableTextColumn.vue'
import TableCheckboxColumn from '@/Shared/Components/Tables/columns/TableCheckboxColumn.vue'
import { defineEmits, defineProps } from 'vue'
import TableViewAction from '../../../Shared/Components/Tables/actions/TableViewAction.vue'
import TableImageColumn from '@/Shared/Components/Tables/columns/TableImageColumn.vue'

const props = defineProps({
  routes: Array,
  checked: Array,
})

const columns = [
  { name: 'Select', slug: '', button: true },
  { name: 'Services', slug: 'service' },
  { name: 'Route', slug: 'route' },
  { name: 'Operator', slug: 'operator' },

  { name: '' },
]

const getRowLink = (row) => {
  return route('explore-bus-options.route.show', row.id)
}

const emits = defineEmits(['update'])

const handleCheckboxChange = (id, checked) => {
  emits('update', { id, checked })
}

const checkDisable = (routeId) => {
  return props.checked.length == 5 && !props.checked.includes(routeId)
}
</script>

<template>
  <div class="overflow-x-auto">
    <Table
      :columns="columns"
      :rows="props.routes"
      is-lite
      :visible-row="10"
    >
      <template #default="{ row }">
        <TableCheckboxColumn
          :disabled="checkDisable(row.id)"
          :checked="props.checked.includes(row.id)"
          @change="handleCheckboxChange(row.id, $event.target.checked)"
        />
        <TableTextColumn :text="row.short_name" />
        <TableTextColumn :text="row.long_name" />
        <TableImageColumn
          :operator-image="true"
          :data="row.agency_main_name"
        />
        <TableViewAction
          :to="getRowLink(row)"
          class="float-right"
          text="View service"
        />
      </template>
    </Table>
  </div>
</template>
